import { render, staticRenderFns } from "./GeometryElement.vue?vue&type=template&id=04ecd9be&scoped=true&"
import script from "./GeometryElement.vue?vue&type=script&lang=js&"
export * from "./GeometryElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ecd9be",
  null
  
)

export default component.exports